function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.65,
  fillRule: "evenodd",
  d: "M7.352.875H2.289a.094.094 0 0 0-.094.094v.75c0 .051.042.093.094.093h2.123L2.584 8.188h-1.9a.094.094 0 0 0-.094.094v.75c0 .052.042.094.094.094h5.062a.094.094 0 0 0 .094-.094v-.75a.094.094 0 0 0-.094-.094H3.56l1.829-6.374h1.964a.094.094 0 0 0 .093-.094v-.75a.094.094 0 0 0-.093-.094z"
});

var SvgItalic = function SvgItalic(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgItalic, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/italic.7ab35358.svg";
export { ForwardRef as ReactComponent };